import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";

interface SupportTicketPayload {
    company_id: number;
    content: string;
    extra?: Record<string, unknown>;
}

interface SupportTicketResponse {
    success: boolean;
    message: string;
}

/**
 * Collect browser and device debug information
 */
export function collectDebugInfo(): Record<string, unknown> {
    return {
        userAgent: navigator.userAgent,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        language: navigator.language,
        platform: navigator.platform,
        timestamp: new Date().toISOString(),
        url: window.location.href,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        touchSupport: "ontouchstart" in window,
    };
}

export function useSupportRequest() {
    return useMutation({
        mutationKey: ["support", "ticket"],
        mutationFn: async (payload: SupportTicketPayload): Promise<SupportTicketResponse> => {
            const { data } = await apiClient.post(apiPath("/public/support/ticket"), payload);
            return data;
        },
    });
}
